// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"132":"forms","138":"profile","225":"rooms","239":"settings-stat","796":"tables","966":"login"}[chunkId] || chunkId) + "." + {"132":"7443481d","138":"5d1ff410","225":"780eb322","239":"ea785a6f","276":"53e427af","796":"cbbb7701","966":"762caa95"}[chunkId] + ".js";
};